module.exports = __webpack_public_path__ + "static/media/portocanal.cc9d2dbe.webp";